<script setup lang="ts">
defineProps<{
  index: number
  title: string
}>()

defineEmits<{
  (e: 'remove'): void
}>()
</script>

<template>
  <div class="border-primary-500 relative flex flex-col gap-y-3 rounded-xl border p-4">
    <div class="flex items-center justify-between">
      <BaseHeading
        tag="h4"
        size="md"
        weight="medium"
      >
        {{ title }} {{ index + 1 }}
      </BaseHeading>

      <BaseButtonIcon
        color="danger"
        shape="curved"
        muted
        class="scale-75"
        @click="$emit('remove')"
      >
        <Icon name="ph:trash" class="size-5" />
      </BaseButtonIcon>
    </div>

    <slot :index="index" />
  </div>
</template>
